import { handleExternalLink } from '@/utils/link-props';
import { Link, LinkProps } from '@cmpsr/components';

export default function CustomLink({ children, ...props }: LinkProps) {
  return (
    <Link size="s" display="inline" textDecoration="underline" {...handleExternalLink(props)}>
      {children}
    </Link>
  );
}
